export default {
    // these are all steps, not just the ones used in the current journey
    allAvailableSteps: {},
    journey: null,
    currentRouteStep: null,
    smallSummaryIntent: 'never',
    applyRoutesLoaded: false,
    loanAmountRange: {
        min: 0,
        max: 9999,
    },
    fieldLoadedEvents: [],
    has: {
        smallSummary: false,
        fullSummary: false,
    },
    backToStep: null,
    data: {
        isHomeowner: {
            value: null,
        },
        campaignType: {
            value: 'personal_loan',
            mappedKey: 'campaign_type',
        },
        poorCredit: {
            value: null,
        },
        optInEmail: {
            value: null,
            mappedKey: 'opt_email',
        },
        optInPhone: {
            value: null,
            mappedKey: 'opt_phone',
        },
        optInSms: {
            value: null,
            mappedKey: 'opt_sms',
        },
        campaignCode: {
            value: window.CAMPAIGN_CODE,
            mappedKey: 'campaign_code',
        },
        cardType: {
            value: null,
            formatterOnQuery: 'numericFormatter',
            mappedKey: 'card_type',
        },
        v1: {
            value: null,
            mappedKey: 'v1',
            validationRules: {},
        },
        v2: {
            value: null,
            mappedKey: 'v2',
            validationRules: {},
        },
        v3: {
            value: null,
            mappedKey: 'v3',
            validationRules: {},
        },
        v4: {
            value: null,
            mappedKey: 'v4',
            validationRules: {},
        },
        v5: {
            value: null,
            mappedKey: 'v5',
            validationRules: {},
        },
        v6: {
            value: null,
            mappedKey: 'v6',
            validationRules: {},
        },
        v7: {
            value: null,
            mappedKey: 'v7',
            validationRules: {},
        },
        v8: {
            value: null,
            mappedKey: 'v8',
            validationRules: {},
        },
        v9: {
            value: null,
            mappedKey: 'v9',
            validationRules: {},
        },
        i1: {
            value: null,
            mappedKey: 'i1',
            validationRules: {},
        },
        i2: {
            value: null,
            mappedKey: 'i2',
            validationRules: {},
        },
        i3: {
            value: null,
            mappedKey: 'i3',
            validationRules: {},
        },
        i4: {
            value: null,
            mappedKey: 'i4',
            validationRules: {},
        },
        i5: {
            value: null,
            mappedKey: 'i5',
            validationRules: {},
        },
        i6: {
            value: null,
            mappedKey: 'i6',
            validationRules: {},
        },
        i7: {
            value: null,
            mappedKey: 'i7',
            validationRules: {},
        },
        i8: {
            value: null,
            mappedKey: 'i8',
            validationRules: {},
        },
        i9: {
            value: null,
            mappedKey: 'i9',
            validationRules: {},
        },
        gclid: {
            value: null,
            mappedKey: 'gclid',
            validationRules: {},
        },
    },
    internal: {
        loanAmount: {
            value: null,
        },
        loanTerm: {
            value: null,
        },
        loanPurpose: {
            value: null,
        },
        residenceType: {
            value: null,
        },
        creditLimit: {
            value: null,
        },
        cardType: {
            value: null,
        },
        contactForm: {
            email: {
                value: null,
            },
            fullName: {
                value: null,
            },
            message: {
                value: null,
            },
        },
        privacyForm: {
            emailAddress: {
                value: null,
            },
            communicationRevoke: {
                value: null,
            },
            analyzeRevoke: {
                value: null,
            },
            shareRevoke: {
                value: null,
            },
        },
    },
    resultReferences: [],
}
